var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header_wrap"},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"fl"},[_vm._v("欢迎访问黄冈师范学院体育场馆中心网站！")]),_vm._v(" "),_c('span',{staticClass:"corner fr"},[_c('ul',[_c('li',[_vm._v(_vm._s(_vm.dateStr))])]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('div',{staticClass:"clear"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-676c355c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopHeader.vue
// module id = null
// module chunks = 